import Swal from "sweetalert2";
import { getInstance } from "./baseapi";

const dataToken = localStorage.getItem("tokenBackoffice");
const instance = getInstance();

export const getBanner = async (queryparams) => {
    try{
        const headers = {
            Authorization: "Bearer " + dataToken,
          };
        const response = await instance.get(`/api/mgr/banner`, {
            headers:headers,
            params: {...queryparams}
        })
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    }catch(error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const getBannerByID = async (id) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/banner/${id}`, {
            headers: headers,
        });
        if (response.status === 200) {
            return await response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const createBanner = async (body) => {
    try {
        const formData = new FormData()
        formData.append('banner_category', body.banner_category)
        formData.append('banner_subcategory', body.banner_subcategory)
        formData.append('supertext_en', body.supertext_en)
        formData.append('supertext_th', body.supertext_th)
        formData.append('format', body.format)
        formData.append('title_en', body.title_en)
        formData.append('title_th', body.title_th)
        formData.append('description_en', body.description_en)
        formData.append('description_th', body.description_th)
        formData.append('publish_date', body.publish_date)
        formData.append('active', body.active)
        if (body.file.length > 0) {
          if(body.file[0].file?.file){
              const blob = new Blob([body.file[0].file?.file], { type: body.file[0].file?.file.type });
              const parts = body.file[0].file?.src.split('/')
              const fileName = parts[parts.length - 1];
              const currentTime = new Date();
              const file = new File([blob], fileName, {
                  type: body.file[0].file?.file.type,
                  lastModified: currentTime.getTime(),
                  lastModifiedDate: currentTime,
                  size: body.file[0].file.size
              });

              formData.append('file', file)
          }
          else{
              formData.append('file', body.file[0].file)
          }
      }
      else{
          formData.append('file', null)
      }
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      for (let entry of formData.entries()) {
    }
      const response = await instance.post(`/api/mgr/banner`, formData, {
        headers: headers,

      });
       
      return response;
    } catch (error) {
      let msg = error.response.status == 400 ? error.response.data.message : error
      Swal.fire({
        icon: "error",
        title: msg,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};

export const updateBannerByID = async (id, body) => {
    try {
        const formData = new FormData()
        formData.append('banner_category', body.banner_category)
        formData.append('banner_subcategory', body.banner_subcategory)
        formData.append('supertext_en', body.supertext_en)
        formData.append('supertext_th', body.supertext_th)
        formData.append('format', body.format)
        formData.append('title_en', body.title_en)
        formData.append('title_th', body.title_th)
        formData.append('description_en', body.description_en)
        formData.append('description_th', body.description_th)
        formData.append('publish_date', body.publish_date)
        formData.append('active', body.active)
        if (body.file.length > 0) {
            if(body.file[0].file?.file){
                const blob = new Blob([body.file[0].file?.file], { type: body.file[0].file?.file.type });
                const parts = body.file[0].file?.src.split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.file[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.file[0].file.size
                });

                formData.append('file', file)
            }
            else{
                formData.append('file', body.file[0].file)
            }
        }
        else{
            formData.append('file', null)
        }
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.put(`/api/mgr/banner/${id}`, formData, {
            headers: headers,
        });

        console.log(`responseBanner4`, response)
        return response;

        
    } catch (error) {
        let msg = error.response.status == 400 ? error.response.data.message : error
        Swal.fire({
            icon: "error",
            title: msg,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const deleteBanner = async (id) => {
    try {
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      const response = await instance.delete(`/api/mgr/banner/${id}`, {
        headers: headers,
      });
  
      if (response.status === 200) {
        return await response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};